module.exports = __webpack_public_path__ + "static/media/A2.6b753016.jpg";